import React, { memo, useContext } from 'react';
import PageContext from '../../../../../contexts/PageContext';
import ResumeTimelineItem from '../../containers/ResumeTimelineItem';
import { safetyCheck } from '../../../../../utils';
import fontSizeOptions from '../../../../../constants/fontSizeOptions';

const LanguageItem = ({ item, fontSize }) => {
  return (
    <div key={item.id} className="flex flex-col">
      <h3
        className="font-semibold"
        style={{ fontSize: fontSizeOptions['text-h3'] + fontSize }}
      >
        {item.name}
      </h3>
      <span style={{ fontSize: fontSizeOptions['text-base'] + fontSize }}>
        {item.fluency}
      </span>
    </div>
  );
};

const LanguagesE = () => {
  const { data, heading: Heading } = useContext(PageContext);
  const colour = data.metadata.colors.primary;
  return safetyCheck(data.languages) ? (
    <>
      <Heading fontSize={data.metadata.margins.fontSize} iconId="languages">
        {data.languages.heading}
      </Heading>
      {data.languages.items.map((x) => (
        <ResumeTimelineItem
          key={x.id}
          colour={colour}
          margin={data.metadata.margins.lrMargins}
        >
          <LanguageItem
            key={x.id}
            item={x}
            fontSize={data.metadata.margins.fontSize}
          />
        </ResumeTimelineItem>
      ))}
    </>
  ) : null;
};

export default memo(LanguagesE);
